var modules_59ffffaf = {"wrapper":"_fmd4bc"};
import "../../../assets/CagdXdkV.css";

export { modules_59ffffaf as default };
//# sourceMappingURL=CommonError.module.less.js.map
